import type { FC } from "react";
import { Spinner, cn } from "~/components/ui";
import { useLanguage } from "~/hooks/useLanguage";
import { asset } from "~/translations/products/asset";

type Props = {
  overlay?: boolean;
  message?: string;
  className?: string;
};

const AssetsPageLoader: FC<Props> = ({
  overlay = false,
  message,
  className,
}) => {
  const { lang } = useLanguage();

  return (
    <div
      className={cn(
        "flex items-center justify-center",
        overlay
          ? "fixed inset-0 z-[100] animate-fade-in bg-secondary/25 backdrop-blur-sm"
          : "min-h-[60vh] w-full",
        className
      )}
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <div className="flex max-w-sm animate-scale-in flex-col items-center gap-5 rounded-2xl border-2 border-secondary/20 bg-white px-10 py-12 shadow-2xl dark:border-white/10 dark:bg-surface">
        <Spinner size="lg" />
        <p className="text-center font-Rubik text-sm font-semibold text-gray-800 dark:text-gray-100">
          {message ?? asset[lang].loadingAssets}
        </p>
      </div>
    </div>
  );
};

export default AssetsPageLoader;
